import styled, { css } from 'styled-components';

const buttonRadius = '16px';
const buttonSize = '32px';
const itemsWidth = '160px';

const containerDisabledStyles = css`
  opacity: 1;
  &:hover {
    color: #3c3c3c;
    background-color: ${props => props.theme.colors.lighter};
  }
`;

const Container = styled.div`
  position: relative;
  display: inline-block;
  transition: all 0.2s;
  cursor: pointer;
  border-top-left-radius: ${buttonRadius};
  border-top-right-radius: ${buttonRadius};
  border-bottom-right-radius: ${buttonRadius};
  border-bottom-left-radius: ${buttonRadius};
  margin-left: 2px;
  margin-right: 2px;
  opacity: 0.5;
  ${props => !props.disabled && containerDisabledStyles};
`;

const MainItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer !important;
  font-size: initial;
  padding: 6px;
  & > * {
    margin-left: 0.5em;
    &:first-child {
      margin-left: 0;
    }
  }
`;

const Items = styled.div`
  display: block;
  position: absolute;
  visibility: hidden;
  opacity: 0;
  transition: all 0.2s;
  top: ${buttonSize};
  ${props => (props.menuExpandDirection === 'right' ? 'left: 0;' : 'right: 0;')}
  min-width: ${itemsWidth};
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 600;
  background-color: ${props => props.theme.colors.lighter};
  border-radius: ${props =>
    props.menuExpandDirection === 'right' ? '0 6px 6px 6px' : '6px 0 6px 6px'};
  white-space: nowrap;
  ${Container}:hover & {
    visibility: visible;
    opacity: 1;
  }
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  position: relative;
  border-bottom: 1px solid #e0e0e0;
  font-weight: 400;
  color: #3c3c3c;
  border-radius: 6px 6px 6px 6px;
  &:hover {
    background-color: #e0e0e0;
  }
  & > * {
    margin-left: 0.5em;
    &:first-child {
      margin-left: 0;
    }
  }
`;

const ItemLabel = styled.div`
  flex: 1;
`;

const ItemActions = styled.div`
  display: flex;
  align-items: center;
`;

export default {
  Container,
  MainItem,
  Items,
  Item,
  ItemLabel,
  ItemActions,
};
